module.exports = __webpack_public_path__ + "static/media/card-image-colegio.e1f8708e.jpg";